export const CurriculumTypes = {
  SECTION: 'section'
};
